export default "__VITE_ASSET__DstuYl0B__"